import { useAccount } from "wagmi";
import { ConnectWallet } from "../components/ConnectWallet";

export function HomePage() {
  const { address, isConnected } = useAccount();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-8">
      <h1 className="text-4xl font-bold mb-8">Crown Sports</h1>
      <p className="text-gray-400 mb-8 text-center max-w-lg">
        Decentralized football score prediction protocol on BSC.
        Predict scores, earn rewards, build your team.
      </p>

      <ConnectWallet />

      {isConnected && (
        <div className="mt-8 space-y-4 text-center">
          <p className="text-sm text-gray-400">Connected: {address}</p>
          <div className="flex gap-4 flex-wrap justify-center">
            <a href="#/matches" className="px-6 py-3 bg-blue-600 rounded-lg hover:bg-blue-700">
              Browse Matches
            </a>
            <a href="#/wallet" className="px-6 py-3 bg-green-600 rounded-lg hover:bg-green-700">
              Wallet
            </a>
            <a href="#/my-bets" className="px-6 py-3 bg-gray-700 rounded-lg hover:bg-gray-600">
              My Bets
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
